<p-toast></p-toast>
<main class="min-h-screen ">
  <router-outlet />
</main>

<!-- Global full-screen loading overlay. Self-hides via AppLoadingService's
     reference count; safe to leave mounted at the root for the whole app. -->
<app-loading></app-loading>

<!-- Full-screen offline page. Shows only while the network is down (driven by
     NetworkStatusService) and dismisses itself when the connection returns. -->
<app-offline></app-offline>
